import { createModel } from "@rematch/core";
import { api } from "api";
import {
  CreateSpecialPlaceCommand,
  UpdateSpecialPlaceCommand,
} from "api/generated/lumen";
import { RootModel } from "app/store";

interface SpecialPlacesCreateState {
  editingItemId?: string;
}

const initialState: SpecialPlacesCreateState = {
  editingItemId: undefined,
};

export const specialPlacesCreate = createModel<RootModel>()({
  state: initialState,
  reducers: {
    setEditingItemId(state, data?: string) {
      state.editingItemId = data;
    },
    resetEditingItemData(state) {
      state.editingItemId = undefined;
    },
    reset: () => initialState,
  },
  effects: (dispatch) => {
    return {
      async create(values: CreateSpecialPlaceCommand): Promise<string> {
        return api.lumen.specialPlaces.apiSpecialPlacesPost({
          createSpecialPlaceCommand: values,
        });
      },

      async edit(values: UpdateSpecialPlaceCommand): Promise<void> {
        return api.lumen.specialPlaces.apiSpecialPlacesIdPut({
          id: values.id,
          updateSpecialPlaceCommand: values,
        });
      },
    };
  },
});
